import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46db0907"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gy-3" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "fullscreen-modal__top-title" }
const _hoisted_4 = { class: "fullscreen-modal__title" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_6 = { class: "ticket-configuration__service-label" }
const _hoisted_7 = { class: "ticket-configuration__selected-services" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "ticket-configuration__price-wrapper" }
const _hoisted_13 = { class: "ticket-configuration__price-label" }
const _hoisted_14 = { class: "ticket-configuration__price" }
const _hoisted_15 = { class: "mt-md-5 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Select = _resolveComponent("Select")!
  const _component_TicketConfigurations = _resolveComponent("TicketConfigurations")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.configure-ticket')), 1),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
      (!_ctx.isPriceCalculator)
        ? (_openBlock(), _createBlock(_component_Breadcrumb, {
            key: 0,
            step: _ctx.step,
            onChangeStep: _ctx.onChangeStep,
            stepViews: _ctx.stepViews
          }, null, 8, ["step", "onChangeStep", "stepViews"]))
        : (_openBlock(), _createBlock(_component_Breadcrumb, {
            key: 1,
            step: _ctx.step,
            onChangeStep: _ctx.onChangeStep,
            stepViews: _ctx.stepViews,
            type: 'pricecalculator'
          }, null, 8, ["step", "onChangeStep", "stepViews"]))
    ]),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.translate('shop.configuration.ticket-configuration')), 1),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.selectedOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getOption(_ctx.selectedOption)?.label), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedUpgrades.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUpgrades, (upgrade) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getUpgrade(upgrade)?.label), 1),
                      _createTextVNode(" | ")
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedInsurance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getInsurance(_ctx.selectedInsurance)?.label), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate('shop.configuration.price-per')), 1),
        _createVNode(_component_Select, {
          label: _ctx.translate('shop.configuration.select-price-group'),
          labelClassName: "visually-hidden",
          selectClassName: "form-select--simple",
          id: "priceGroup",
          name: "priceGroup",
          selectedOption: _ctx.selectedPriceGroup,
          onChangeValue: _ctx.onChangePriceGroup,
          options: _ctx.allPriceGroups
        }, null, 8, ["label", "selectedOption", "onChangeValue", "options"]),
        _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.priceString), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_TicketConfigurations, {
        ticketId: _ctx.ticketId,
        selectedDateStart: _ctx.selectedDateStart,
        selectedDateEnd: _ctx.selectedDateEnd,
        selectedOption: _ctx.selectedOption,
        onChangeOption: _ctx.onChangeOption,
        selectedInsurance: _ctx.selectedInsurance,
        onChangeInsurance: _ctx.onChangeInsurance,
        selectedUpgrades: _ctx.selectedUpgrades,
        onChangePriceConfiguration: _ctx.onChangePriceConfiguration,
        onChangeUpgrades: _ctx.onChangeUpgrades,
        onChangeAllOptions: _ctx.onChangeAllOptions,
        onChangeAllInsurances: _ctx.onChangeAllInsurances,
        onChangeAllUpgrades: _ctx.onChangeAllUpgrades,
        onChangeAllPriceGroups: _ctx.onChangeAllPriceGroups,
        onChangeTicketConfigurations: _ctx.onChangeTicketConfigurations,
        onChangePriceGroup: _ctx.onChangePriceGroup,
        onChangePrice: _ctx.onChangePrice,
        ticketConfigurations: _ctx.ticketConfigurations,
        selectedPriceConfiguration: _ctx.selectedPriceConfiguration,
        selectedCurrency: _ctx.selectedCurrency,
        selectedPriceGroup: _ctx.selectedPriceGroup,
        allPriceGroups: _ctx.allPriceGroups,
        isInPriceCalculator: _ctx.isPriceCalculator ? true : null
      }, null, 8, ["ticketId", "selectedDateStart", "selectedDateEnd", "selectedOption", "onChangeOption", "selectedInsurance", "onChangeInsurance", "selectedUpgrades", "onChangePriceConfiguration", "onChangeUpgrades", "onChangeAllOptions", "onChangeAllInsurances", "onChangeAllUpgrades", "onChangeAllPriceGroups", "onChangeTicketConfigurations", "onChangePriceGroup", "onChangePrice", "ticketConfigurations", "selectedPriceConfiguration", "selectedCurrency", "selectedPriceGroup", "allPriceGroups", "isInPriceCalculator"])
    ])
  ]))
}